import React from 'react';
import Image from '../../../components/AppImage';

const ClientLogos = () => {
  const clients = [
    {
      name: 'TechCorp Solutions',
      logo: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=200&h=100&fit=crop&crop=center',
      industry: 'Technology',
      employees: '500+'
    },
    {
      name: 'MedHealth Systems',
      logo: 'https://thumbs.dreamstime.com/b/digital-health-landing-page-background-concept-hero-banner-design-human-heart-outline-vector-illustration-medical-176132057.jpg?w=200&h=100&fit=crop&crop=center',
      industry: 'Healthcare',
      employees: '250+'
    },
    {
      name: 'Financial Partners',
      logo: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=200&h=100&fit=crop&crop=center',
      industry: 'Finance',
      employees: '300+'
    },
    {
      name: 'Creative Media Group',
      logo: 'https://images.unsplash.com/photo-1572021335469-31706a17aaef?w=200&h=100&fit=crop&crop=center',
      industry: 'Media',
      employees: '150+'
    },
    {
      name: 'Manufacturing Plus',
      logo: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=200&h=100&fit=crop&crop=center',
      industry: 'Manufacturing',
      employees: '800+'
    },
    {
      name: 'Retail Excellence',
      logo: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=200&h=100&fit=crop&crop=center',
      industry: 'Retail',
      employees: '400+'
    },
    {
      name: 'Education First',
      logo: 'https://thumbs.dreamstime.com/b/education-school-hero-header-top-view-items-57336735.jpg?w=200&h=100&fit=crop&crop=center',
      industry: 'Education',
      employees: '600+'
    },
    {
      name: 'Global Logistics',
      logo: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=200&h=100&fit=crop&crop=center',
      industry: 'Logistics',
      employees: '350+'
    }
  ];

  const testimonials = [
    {
      quote: "Xtreem Fibre Solutions transformed our network infrastructure with zero downtime. The 50x speed improvement has revolutionized our operations.",
      author: "Sarah Chen",
      title: "IT Director",
      company: "TechCorp Solutions",
      rating: 5
    },
    {
      quote: "Outstanding service and expertise. Our hospital now has the reliable connectivity we need for critical patient care systems.",
      author: "Dr. Michael Rodriguez",
      title: "CTO",
      company: "MedHealth Systems",
      rating: 5
    },
    {
      quote: "The ROI was immediate. Our trading systems now operate at peak performance with fiber-optic reliability.",
      author: "Jennifer Walsh",
      title: "Infrastructure Manager",
      company: "Financial Partners",
      rating: 5
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center space-y-4 mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900">
            Trusted by Industry Leaders
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Join hundreds of businesses that have transformed their infrastructure with Xtreem Fibre Solutions
          </p>
        </div>

        {/* Client Logos Grid */}
        <div className="mb-16">
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-8 items-center">
            {clients?.map((client, index) => (
              <div
                key={index}
                className="group relative bg-white rounded-lg p-6 shadow-brand-subtle border hover:shadow-brand-moderate transition-all duration-300 trust-glow"
              >
                <div className="aspect-w-3 aspect-h-2 mb-3">
                  <Image
                    src={client?.logo}
                    alt={`${client?.name} logo`}
                    className="w-full h-16 object-contain filter grayscale group-hover:grayscale-0 transition-all duration-300"
                  />
                </div>
                <div className="text-center">
                  <h3 className="text-sm font-semibold text-slate-900 mb-1">
                    {client?.name}
                  </h3>
                  <p className="text-xs text-slate-500">{client?.industry}</p>
                  <p className="text-xs text-slate-400">{client?.employees}</p>
                </div>

                {/* Hover Tooltip */}
                <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-slate-900 text-white text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap z-10">
                  {client?.industry} • {client?.employees} employees
                  <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-slate-900"></div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Performance Metrics */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          <div className="text-center bg-white rounded-xl p-8 shadow-brand-moderate border">
            <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-2xl font-bold text-emerald-600">99.9%</span>
            </div>
            <h3 className="text-xl font-semibold text-slate-900 mb-2">Project Success Rate</h3>
            <p className="text-slate-600">
              Consistently delivering successful fiber installations with minimal disruption
            </p>
          </div>

          <div className="text-center bg-white rounded-xl p-8 shadow-brand-moderate border">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-2xl font-bold text-blue-600">10x</span>
            </div>
            <h3 className="text-xl font-semibold text-slate-900 mb-2">Average Speed Improvement</h3>
            <p className="text-slate-600">
              Typical performance gains from copper to fiber infrastructure upgrades
            </p>
          </div>

          <div className="text-center bg-white rounded-xl p-8 shadow-brand-moderate border">
            <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-2xl font-bold text-amber-600">24/7</span>
            </div>
            <h3 className="text-xl font-semibold text-slate-900 mb-2">Support Availability</h3>
            <p className="text-slate-600">
              Round-the-clock monitoring and emergency response for critical systems
            </p>
          </div>
        </div>

        {/* Client Testimonials */}
        <div className="grid lg:grid-cols-3 gap-8">
          {testimonials?.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-8 shadow-brand-moderate border social-proof-card"
            >
              {/* Rating Stars */}
              <div className="flex items-center space-x-1 mb-4">
                {[...Array(testimonial?.rating)]?.map((_, i) => (
                  <svg
                    key={i}
                    className="w-5 h-5 text-amber-400 fill-current"
                    viewBox="0 0 20 20"
                  >
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
              </div>

              {/* Quote */}
              <blockquote className="text-slate-700 mb-6 leading-relaxed">
                "{testimonial?.quote}"
              </blockquote>

              {/* Author */}
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-emerald-500 rounded-full flex items-center justify-center">
                  <span className="text-white font-semibold text-lg">
                    {testimonial?.author?.split(' ')?.map(n => n?.[0])?.join('')}
                  </span>
                </div>
                <div>
                  <div className="font-semibold text-slate-900">{testimonial?.author}</div>
                  <div className="text-sm text-slate-600">{testimonial?.title}</div>
                  <div className="text-sm text-slate-500">{testimonial?.company}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-12">
          <div className="bg-gradient-to-r from-blue-600 to-emerald-600 rounded-xl p-8 text-white">
            <h3 className="text-2xl font-bold mb-4">
              Join Our Growing Network of Satisfied Clients
            </h3>
            <p className="text-blue-100 mb-6 max-w-2xl mx-auto">
              Experience the same transformation and reliability that industry leaders trust. 
              {/* Get your free network assessment today. */}
            </p>
            {/* <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-blue-50 transition-colors">
                View Case Studies
              </button>
              <button className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white/10 transition-colors">
                Get Free Assessment
              </button>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientLogos;